import { FC, ReactNode } from "react";
import {
  TabPanel as ReactTabPanel,
  TabPanelProps as ReactTabPanelProps,
} from "react-tabs";
import cn from "classnames";
import { useTabsContext } from "../tabs-context";
import DisabledTabPanel from "./disabled-tab-panel";

export interface TabPanelProps extends ReactTabPanelProps {
  children: ReactNode;
  className?: string;
}

export interface TabPanelComponent extends FC<TabPanelProps> {
  tabsRole: string;
}

const TabPanel: TabPanelComponent = (props) => {
  const { children, className, ref, ...rest } = props;

  const { getBemBlocksWith, isDisabled } = useTabsContext();

  if (isDisabled) {
    return (
      <DisabledTabPanel data-auto="disabled-tab-panel" className={className}>
        {children}
      </DisabledTabPanel>
    );
  }

  return (
    <ReactTabPanel
      data-auto="tab-panel"
      className={cn(className, getBemBlocksWith("__tab-panel"))}
      selectedClassName={getBemBlocksWith("__tab-panel--selected")}
      {...rest}
    >
      {children}
    </ReactTabPanel>
  );
};

TabPanel.tabsRole = "TabPanel";

export default TabPanel;
